import React from 'react';
import PropTypes from 'prop-types';

import './tileContainer.scss';

const TileContainerView = props => (
  <div className={'o-tile-container'}>
    {props.tiles}
  </div>

);


TileContainerView.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.node),
};

TileContainerView.defaultProps = {
  tiles: [],
};

export default TileContainerView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Tiles/TileContainer/TileContainerView.jsx